import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { formatArrivalDate } from "../../../../../../utils/Functions";
import { ItineraryService } from "../../../../../../shared/itinerary.service";
import { ConfirmationModalComponent } from "../../../../../../shared/modals/confirmation-modal/confirmation-modal.component";
import { MaterialModalConfirmComponent } from "../../../../../../shared/material-modal-confirm/material-modal-confirm.component";
import { MatDialog } from "@angular/material/dialog";
import * as moment from "moment";
import { BsModalRef, BsModalService, ModalOptions } from "ngx-bootstrap/modal";
import { UserService } from "app/pages/com.usblick.common/auth/user.service";
import { ResultsSearchService } from "app/home/results-search.service";
import { RestService } from "app/shared/rest.service";
import { ModalLoadingComponent } from "app/shared/modal-loading/modal-loading.component";
import { MaterialModalAlertComponent } from "app/shared/material-modal-alert/material-modal-alert.component";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpErrorResponse } from "@angular/common/http";
import { CurrencyConverterPurePipe } from "app/shared/currency-converter-pure.pipe";
import { NotificationService } from "app/shared/notifications/notification.service";

@Component({
  selector: "usb-item-rentacar",
  templateUrl: "./item-rentacar.component.html",
  styleUrls: ["./item-rentacar.component.scss"],
providers: [CurrencyConverterPurePipe]
})
export class ItemRentacarComponent implements OnInit {
  @Input() dato: any;
  @Input() pickUp?: number;
  @Input() isCheckIn: boolean;
  @Input() isCheckOut: boolean;
  @Input() partialReserve: boolean;
  @Input() currencyAgency: any;
  @Input() clientSetting: any;
  @Input() currencies: any;
  @Input() permissions: any[] = [];
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() delete = new EventEmitter<number>();
  @Output() cancel = new EventEmitter<string>();
  fontSizeAdjustments = { 6: -1, 8: -2, 10: -5 };

  public formatDate = formatArrivalDate;

  bsModalRef?: BsModalRef;

  constructor(
    private itineraryService: ItineraryService,
    private modalService: BsModalService,
    private dialog: MatDialog,
    private resultsSearch: ResultsSearchService,
    private _restService: RestService,
    public userService: UserService,
    private router: Router,
    private notificationService: NotificationService,
    private ngxSpinner: NgxSpinnerService,
     private currencyPipe: CurrencyConverterPurePipe
  ) {}

  ngOnInit() {
  }

  ngOnChanges() {
  }

  removeItem(item: any) {
    let message = "";

    if (item.status_id == 1 || item.status_id == 5) {
      message = "Esta seguro de Eliminar el Producto?";
    }
    if (item.status_id == 2) {
      if (this.verifiedReservationId(item)) {
        message = "Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?";
      } else {
        message = "¿Esta seguro de cancelar el producto?";
      }
    }

    const initialState: ModalOptions = {
      initialState: {
        title: item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      },
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if (result) {
        const paxesQty = {
          destination: item.destination?.iata_code,
          adults: Number(item.paxAdults),
          children: Number(item.paxChildren),
        };
        this.userService.itineraryActive[0]["destination"].forEach((destination: any) => {
          if (destination.iata_code === paxesQty.destination) {
            destination.destination_info.adults -= paxesQty.adults;
            destination.destination_info.childs -= paxesQty.children;
          }
        });
        if (item.status_id == 1 || item.status_id == 5) {
          this.deleteItem(item);
        }
        if (item.status_id == 2) {
          this.cancelReservation(item);
        }
      } else {
      }
      confirmSubscription.unsubscribe();
    });
  }

  toPartialReserve(event, item: any) {
    if (event.target.checked) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item, true);
      this.itemToPartial.emit(-1);
    }
  }

  subtractDays(date) {
    return moment(moment(date)).subtract(2, "days").format("YYYY-MM-DD");
  }

  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stingUpperCase(str) {
    if (str) {
      let e = str.toLowerCase();
      return e.replace(/\b\w/g, (l) => l.toUpperCase());
    }
  }

  fontPrice(price) {
    if (price.length - 6 > 0) {
      const fact = price.length - 6;
      const size = 25 - 1.5 * fact;
      return size + "px";
    }
  }

  edit(item: any) {
    // modo quoute
    if (item.status_id == 1) {
      const message =
        "¿Deseas eliminar este item y buscar un nuevo " +
        item.categoryName +
        " en " +
        item.location +
        " del " +
        this.returnDate(item.arrivalDate) +
        " hasta " +
        this.returnDate(item.departureDate) +
        " para " +
        item.paxAdults +
        " adultos?";

      const initialState: ModalOptions = {
        initialState: {
          title: 'Eliminar',
          message: message.replace(/\?/g, '?<br />'),
          icon: 'assets/icons/itinerary-detail/04-01.svg'
        },
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
        if (result) {
          await this.makePayload(item);
          await this.itineraryService.remove(item !== undefined ? item : item);
        } else {
        }
        confirmSubscription.unsubscribe();
      });
    }
  }

  returnDate(date: any) {
    let dateSplit = date.split("-");
    return (
      "" +
      dateSplit[2] +
      "-" +
      moment()
        .month(parseInt(dateSplit[1]) - 1)
        .format("MMM")
    );
  }

  makePayload(item: any) {
    const _payload = [];

    const payload = item.payloadUpdate.products[0];
    const form = item.form;
    _payload[0] = payload;

    localStorage.setItem("form", JSON.stringify(form));
    localStorage.setItem("payload", JSON.stringify(_payload));
    this.openModalLoading(JSON.parse(localStorage.getItem("payload")));
    this._restService.doPost("app", "search", payload).subscribe(
      (response: any) => {
        if (response !== null && response.results !== null) {
          const payloadArray = [payload];
          this.resultsSearch._setPayload(payloadArray);
          localStorage.setItem("form", JSON.stringify(form));
          localStorage.setItem("payload", JSON.stringify(payloadArray));
          this.resultsSearch._setOrigin(item.categoryName);

          this._setSearchIdInResults(response);
          if (response.results.length > 0) {
            this._handleResponse(response, item.categoryName, item);
            this.dialog.closeAll();
            this.itineraryService.notifyModalClosed(true);
            this.router.navigate(["/results"]);
          } else {
            var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
              height: "auto",
              width: "350px",
              data: "No se encontraron Resultados",
              disableClose: true,
            });
          }
        }
      },
      (error) => {
        const message = "Ocurrió un error al intentar encontrar productos";
        this.dialog.closeAll();
        var dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
          width: "450px",
          data: { message: message },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) {
            this.makePayload(item);
          } else {
            this.dialog.closeAll();
          }
        });
      }
    );
  }

  openModalLoading(data: any) {
    var dialogRef = this.dialog.open(ModalLoadingComponent, {
      width: "650px",
      id: "loadModal",
      data: data,
      disableClose: true,
    });

    /* dialogRef.afterClosed().subscribe(result => {
            });*/
  }

  _setSearchIdInResults(response: any) {
    response.results.forEach((obj) => {
      obj.searchId = response.searchId;
    });
  }

  _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = payload.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = "No results found for the search";
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log("error", e);
      }
    }
  }

  verifiedReservationId(item): boolean {
    let matchReservationId: any[] = [];
    switch (item?.category_id) {
      case 1:
        matchReservationId = this.userService.itineraryActive[0].items.filter(
          (c) => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId
        );
        break;
      case 2:
        matchReservationId = this.userService.itineraryActive[0].items.filter(
          (c) => c.resultReserve?.providerReservationId === item?.resultReserve?.additionalInfo?.idReservation
        );
        break;
      case 6:
        matchReservationId = this.userService.itineraryActive[0].items.filter(
          (c) => c.resultReserve?.providerReservationId === item?.resultReserve?.additionalInfo?.idReservation
        );
        break;
      case 8:
        matchReservationId = this.userService.itineraryActive[0].items.filter(
          (c) => c.resultReserve?.providerReservationId === item?.resultReserve?.providerReservationId
        );
        break;
    }

    return matchReservationId && matchReservationId.length > 1;
  }

  deleteItem(item: any) {
    this.itineraryService.remove(item !== undefined ? item : item);
    setTimeout(() => {
      this.delete.emit(item.id);
      this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

  cancelReservation(item: any) {
    const productsIdArr = [item.id];
    this.ngxSpinner.show();
    let cancelData: any = {};
    switch (item?.category_id) {
      case 1:
        cancelData["providerId"] = item?.providerId;
        cancelData["reservationLocator"] = item?.resultReserve?.providerReservationId;
        cancelData["productsId"] = productsIdArr;
        break;
      case 2:
        cancelData["providerId"] = item?.providerId;
        cancelData["reservationLocator"] = item?.resultReserve?.providerReservationId;
        cancelData["productsId"] = productsIdArr;
        break;
      case 6:
        cancelData["providerId"] = item?.providerId;
        cancelData["reservationLocator"] = item?.resultReserve?.additionalInfo?.idReservation;
        cancelData["productsId"] = productsIdArr;
        break;
      case 8:
        cancelData["providerId"] = item?.providerId;
        cancelData["reservationLocator"] = item?.resultReserve?.providerReservationId;
        cancelData["productsId"] = productsIdArr;
        break;
    }

    const itemCancelled = this.userService.itineraryActive[0].items.find((c) => c.id === item.id);

    itemCancelled.amount_convert_cancellation = this.getCancellationPolicies(itemCancelled.category_id, item);
    this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

    this._restService.doPut("app", `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
      next: (res: any) => {
        this.ngxSpinner.hide();
        this.cancel.emit(item.id);
        this.notificationService.success("Su producto fue cancelado con éxito");
        this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
      },
      error: (error: HttpErrorResponse) => {
        this.ngxSpinner.hide();
        this.notificationService.error("Ocurrio un error");
        console.log(error);
      },
    });
    // this.itineraryService.cancelReservation(item);

    // setTimeout(() => {
    //   this.cancel.emit(item.id);
    //   this.userService.updateProductsPrices(item.itinerary_id);
    // }, 1000);
  }

  getCancellationPolicies(category, item) {
    const currentDate = new Date();
    const defaultPolicy = {
      currency: this.currencyAgency?.code,
      from: currentDate,
      amount: 0,
      apply: false,
    };

    let policies = [];
    if (category === 1) {
      policies = item.room?.cancellationPolicy || [];
    } else if (category === 8) {
      policies = item.cancellationPolicies || [];
    }

    if (policies.length === 0) {
      return [defaultPolicy];
    }

    const sortedPolicies = [...policies].sort((a, b) => new Date(a.from).getTime() - new Date(b.from).getTime());

    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
      if (new Date(sortedPolicies[i].from) <= currentDate) {
        applicableIndex = i;
      } else {
        break;
      }
    }

    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find((c) => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

      const isApplicable = index === applicableIndex;
      const amount = (policy.amount / baseRate) * targetRate;

      return {
        ...policy,
        currency: this.currencyAgency?.code,
        amount: amount,
        apply: isApplicable,
      };
    });

    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map((policy) => ({
        ...policy,
        currency: this.currencyAgency?.code,
        amount: (policy.amount / this.currencies.find((c) => c.code === policy.currency)?.rate) * targetRate2,
        apply: false,
      }));
    }

    return result;
  }

      getPrice(item): number {

      if(item.status_id == 5) {
        return 0;
      }

      let price: number;
      if(!item.isPendigApprovePay && !item.isPaidAgency && !item.isPaidProvider) {
        price = item.netPriceAgent;

        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );
      }

      if(item.isPendigApprovePay || item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          price = item.converted_amounts.netPriceAgent;
        } else {
          price = item.netPriceAgent;
        }


      }

      return price

    }
}
